module.exports = __webpack_public_path__ + "img/Overlay (1).eb6113d1.png";